
import { PlateSelectionContext } from './PlateSelectionProvider';
import { useContext } from 'react';

export default function PlateWell({row,col,gridId,setHover,onClick, hoverMap,cell,experiment, showText, fontSize=8, substanceRanges, substanceOpacityMap }){

  const selectedItems = useContext(PlateSelectionContext);

  let { wells=[] } = selectedItems;

  let isSelected = wells.find(ww => {
    return (
      row === ww.row && col === ww.col && gridId === ww.gridId
    )
  })

  

  


  

  const dim = 40;
  let proposedValue = hoverMap[row]?.[col];

  


  let proposedOverwrites = false;
  let proposedEqualsPrevious = false;

  let { variableMap } = experiment;

  

  let substanceDivs = [];
  cell.forEach((liquid,iiLiquid) => {

   




    if( !liquid ){ return; }




    let subId = liquid.substance; 

    let opacity = substanceOpacityMap[subId][liquid.value];

    /*
    let range = substanceRanges[subId].sort();
    let rMin = range[0];
    let rMax = range[range.length-1];

    let logRange = Math.log(rMax/rMin);


    let opacity;
    
    if( logRange > 3 ){

      let val = Math.min(liquid.value+5,rMax);
      opacity = Math.log(val/rMin) / Math.log(rMax/rMin);
    }else{
      let val = Math.min(liquid.value + 0.1*(rMax-rMin), rMax);
      opacity = (val-rMin) / (rMax-rMin);
    }
    */


    

    //(liquid.value - rMin) / (rMax - rMin); 


    let substanceName = variableMap[subId].substance;
    let displayText = variableMap[subId].displayText;
    let color = variableMap[subId].color;
   

    let overallBackground = color;//"white";


    let textColor="white";
    if( proposedValue?.substance === substanceName ){

      proposedOverwrites = true;

      if( proposedValue?.value === liquid.value ){
        proposedEqualsPrevious = true;
      }else{
        overallBackground = "yellow";
        //="black";
      }


      
            
    }

    

    // is it proposed? overwriting? nothign

    

    if( showText ){


      let liquidContent = (
        <div style={{

          overflow:'hidden',
          whiteSpace:'nowrap',

          textOverflow:'ellipsis',
          textAlign:'center', zIndex:100}}
          class="rel"
        >
          {false && <div>{Number(opacity).toFixed(3)}</div>}

          {showText?.circle && <div class="flex-expand" style={{width:4,height:4, borderRadius:8, 

            background:color,

          marginRight:2}}/>}
          {showText?.label && <div class="full-width" style={{

            textOverflow:'ellipsis',

            overflow:'hidden',
            whiteSpace:'nowrap',
            
          }}>{displayText}</div>}
          {showText?.value && (

            <div>{liquid.value} {liquid.units}</div>

          )}

        </div>
      )

      substanceDivs.push(
        <div onClick={() => {

          let toSelect = { liquid:{row,col,gridId,substanceId:iiLiquid} };

        }} style={{
          color:(opacity < 0.75 ? "black" : "white"),//textColor,
          //background:overallBackground,
          //opacity,
          }} class={`rel sg-row v-center outline-on-hover rel rise-on-hover liquid flex-expand h-center`}>
          <div class="absolute-cover npe" style={{
            background:overallBackground,
            opacity
          }}/>
          {true && <div class="hidden-until-parent-hover absolute-cover"/>}
          {liquidContent}
        </div>
      )
    }else{

      debugger;

      substanceDivs.push(
        <div class="flex-expand" style={{
          background:color,
          opacity,
        }}/>
      )


    }
  })

  return (
    <div class="rel sg-col tiny-padding" onClick={onClick}
      onMouseEnter={() => setHover({gridId, pos:[row,col]})} 
      style={{
        width:dim, aspectRatio:'1 / 1',
        
        //border:'1px solid #ccc',
        outline:'1px solid #ccc',

        fontSize,
      }}>

      {true && <div style={{
      }} class="absolute-cover outline-on-hover rise-on-hover"/>}


      {substanceDivs}

      {proposedValue?.substance && proposedValue && !proposedOverwrites && (
        <div style={{lineHeight:0.77, background:'cyan',borderRadius:5,paddingLeft:2, textAlign:'center'}}>
          <div style={{lineHeight:0.77}}>{proposedValue?.substance}</div>
          <div>{proposedValue?.value} {proposedValue?.units}</div>
        </div>
      )}

      {isSelected &&  <div style={{zIndex:10000}} class="selected-item-cover"/>}
    </div>
  )
}
